import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import Button from '../../generic-components/Button';
import { Timer } from '../../assets/svg';
import { SESSION_POPUP_TIMES } from '../../constants/general';
import { INACTIVE_MODAL_STYLES, INACTIVE_LABELS } from './constants';
import { useStore } from '../../store';
import { useLogoutQuery } from '../../hooks/query/useLogoutQuery';

interface IProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const InactiveModal = ({ isOpen, onRequestClose }: IProps) => {
  const [counter, setCounter] = useState(SESSION_POPUP_TIMES.COUNTER);
  const navigate = useNavigate();
  const { customerId } = useStore(state => state.currUser());
  const { refetch: sendLogout } = useLogoutQuery({
    customerId,
    onSuccess: () => {
      localStorage.clear();
      onRequestClose();
      navigate('/login');
    },
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCounter(counter - 1);
    }, SESSION_POPUP_TIMES.COUNTER_TIME);

    if (counter <= 0) {
      sendLogout().finally(() => onRequestClose());
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [counter]);

  const { t } = useTranslation();

  return (isOpen ? (
    <UserMessage id='inactiveUserMessage' onClick={onRequestClose}>
      <div className={INACTIVE_MODAL_STYLES.MODAL_CONTAINER}>
        <img className={INACTIVE_MODAL_STYLES.ICON} src={Timer} alt='icon' />
        <span className={INACTIVE_MODAL_STYLES.TEXT_1}>{t(INACTIVE_LABELS.STILL_WITH_US)}</span>
        <span className={INACTIVE_MODAL_STYLES.TEXT_2}>
          {t(INACTIVE_LABELS.YOUVE_BEEN_GONE)}
          <span className={INACTIVE_MODAL_STYLES.COUNTER}>
            {`${counter} `}
            Sec.
          </span>
        </span>
        <Button
          id='stayInAppInactive'
          onClick={onRequestClose}
          className={INACTIVE_MODAL_STYLES.STAY_LOGIN_BTN}
          title={t(INACTIVE_LABELS.STAY_IN)}
        />
        <Button
          id='logOutInactive'
          onClick={sendLogout}
          className={INACTIVE_MODAL_STYLES.LOGOUT_BTN}
          title={t(INACTIVE_LABELS.LOG_OUT)}
        />
      </div>
    </UserMessage>
  ) : null);
};

export default InactiveModal;
